import Avatar, { AvatarProps } from "@/shared/data-display/avatar";
import { EyeInvisibleOutlined } from "@ant-design/icons";

/**
 * Аватар, к которому нет доступа. Иконка та же, что у плашки «скрыто», — иначе закрытое
 * правами фото не отличить от незагруженного.
 */
export function HiddenAvatarView(props: AvatarProps) {
  return <Avatar icon={<EyeInvisibleOutlined />} {...props} />;
}
